// extracted by mini-css-extract-plugin
export default {"itemContainer":"BarItem_itemContainer__bvX40","itemPercent":"BarItem_itemPercent__k5OTI","itemText":"BarItem_itemText__UhraD"};